export default {
    setRedisChange (state:any, value:any) {
        state.isRedisChange = value;
    },
};
